module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/18VaiDN/tc-custom/9781398454293.jpg?1705687990272",
      "alt": "This image is the cover for the book Pulling the Rug"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pulling the Rug\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“You have to come, now.” Those were the words that up ended Emma’s world and pulled the rug firmly out from under her feet. Up until that point her life had been relatively charmed: A good job. A lovely house. A handsome husband. Fancy coffee. Holidays with sun and adventure. One day she would settle down. One day she wanted children. One day. One car accident and her world spun out of its axis. A ready-made family crashed her ordered world. A mutinous teenager, a traumatized little girl, crazy twins and a long-suffering cat. Everyone had advice. Everyone had an opinion. She thought she was strong, capable, she always had a plan. She always had a plan A, B and C to be precise. But what happens when someone pulls away the rug?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Beckie-Jo Browne\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Beckie-Jo currently lives in Lancashire where she enjoys teaching, singing, and coming up with ‘genuis plans’. The children that she teaches will tell you that she’s funny but fair, her family will tell you that she’s never frightened to tell you what she’s thinking and her friends will tell you that she always has a good story to tell. Her smile is infectious, and her love of mischief means life around her is never dull. She thrives on people telling her, ‘you can’t possibly do that, to ensure that she most definitely can!’ She identifies tomato sauce as one of the five main food groups, her piano as her desert island disk and her life as a series of adventures to be lived whether laughing or crying.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0